export function toHeikinAshi(rows) {
  const out = [];
  for (let i = 0; i < rows.length; i++) {
    const c = rows[i];
    const close = (c.open + c.high + c.low + c.close) / 4;
    const open = i === 0 ? (c.open + c.close) / 2 : (out[i - 1].open + out[i - 1].close) / 2;
    out.push({
      time: c.time,
      open,
      high: Math.max(c.high, open, close),
      low: Math.min(c.low, open, close),
      close,
    });
  }
  return out;
}
